/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

let bootstrapComponent = {};

if (process.env.BOOTSTRAP_ENABLED) {
  bootstrapComponent = {
    templateUrl: 'ajs/bootstrap/bootstrap.html',
    bindings: {
      devLogin: '=',
      title: '<',
    },
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    controller: ['$log', '$window', 'Restangular', 'BulbAuthService', BootstrapController],
  };

  // eslint-disable-next-line no-inner-declarations
  function BootstrapController($log, $window, Restangular, BulbAuthService) {
    const that = this;

    this.developerLogins = this.devLogin.developers;
    this.status = '';
    this.numberOfStudents = 500;
    this.educatorCount = 1;
    this.studentCount = 2;
    this.classLinkLogins = [];

    this.loginAs = function loginAs(email, password) {
      BulbAuthService.signIn({ usernameOrEmail: email, password }).then((account) => {
        // FUTURE : we currently do a full reload so that we can refresh permissions on all data for the
        // successful sign in.  In the future, it would be nice to clean/refresh the client state without the
        // reload, but this is the easiest way to handle it for now.
        // Reload using user's profile page:
        // eslint-disable-next-line no-param-reassign
        $window.location.href = `/${account.username}`;
      });
    };

    this.doCommand = function doCommand(command) {
      Restangular.all(`bootstrap/${command}`).customPOST().then((data) => {
        if (data.status) {
          that.status = data.status;
        } else {
          that.status = `Command: ${command} completed`;
        }
        if (command.indexOf('create_org') !== -1) {
          that.refreshOrgAccounts();
        }
      }, (error) => {
        that.status = 'ERROR - see console';
        $log.debug(`error is ${angular.toJson(error)}`);
      });
    };

    this.createTestOrg = function createTestOrg(isBSD) {
      const params = {
        bsd: isBSD,
        educatorCount: that.educatorCount,
        studentCount: that.studentCount,
      };

      Restangular.all('bootstrap/create_org').customPOST({}, '', params).then((data) => {
        that.status = data.status;
        that.refreshOrgAccounts();
      }, (error) => {
        that.status = 'ERROR - see console';
        $log.debug(`error is ${angular.toJson(error)}`);
      });
    };

    this.createClasslinkAccounts = function createClasslinkAccounts() {
      Restangular.all('bootstrap/create_classlink').customPOST().then((data) => {
        that.status = data.status;
        that.classLinkLogins = data.logins;
      }, (error) => {
        that.status = 'ERROR - see console';
        $log.debug(`error is ${angular.toJson(error)}`);
      });
    };

    this.logout = function logout() {
      BulbAuthService.signOut('/b/bootstrap/', false);
    };

    this.signInViaClasslink = function signInViaClasslink() {
      // eslint-disable-next-line no-param-reassign
      $window.location = '/b/auth/classLink';
    };

    this.refreshOrgAccounts = function refreshOrgAccounts() {
      Restangular.one('bootstrap/org_login').get().then((orgLogin) => {
        that.orgLogins = orgLogin.orgAccounts;
      });
    };

    this.refreshOrgAccounts();
  }
}

export default bootstrapComponent;
